import { APP_CONFIG } from './app.config';

export const API_BASE_URL = APP_CONFIG.apiBaseUrl + "/";
export const AVATAR_URL = APP_CONFIG.s3Url + "user-avatar/";
export const PDF_URL = APP_CONFIG.s3Url + "material-lake/";

export const API_ENDPOINT = {
  AUTH: {
    LOGIN: API_BASE_URL + 'auth/login',
    LOGOUT: API_BASE_URL + 'auth/logout',
    REFRESH_TOKEN: API_BASE_URL + 'auth/refresh-token',
    STREAM_DRIVE: API_BASE_URL + 'auth/stream-drive',
    CHANGE_PASSWORD: API_BASE_URL + 'auth/change-password',
    RESET_PASSWORD: API_BASE_URL + 'auth/reset-password',
  },
  USER: {
    BASE_URL: API_BASE_URL + 'users',
    SAVE_INFO: API_BASE_URL + 'users/save-admin-and-teacher',
    GET_ALL: API_BASE_URL + 'users/get-all',
    SAVE_BULK: API_BASE_URL + 'users/save-bulk',
    GET_CLASSES: API_BASE_URL + 'users/classes',
  },
  SEMESTER: {
    GET_ALL: API_BASE_URL + 'semester/get-all',
    SAVE: API_BASE_URL + 'semester/save-many',
  },
  MAJORS: {
    GET_ALL: API_BASE_URL + 'majors/get-all',
    CREATE: API_BASE_URL + 'majors/create',
    UPDATE: API_BASE_URL + 'majors/update',
    GET_ALL_ACTIVE: API_BASE_URL + 'majors/get-all-active',
  },
  COURSE: {
    GET_ALL: API_BASE_URL + 'course/get-all',
    CREATE: API_BASE_URL + 'course/create',
    UPDATE: API_BASE_URL + 'course/update',
    GET_ALL_ACTIVE: API_BASE_URL + 'course/get-all-active',
    DETAIL: API_BASE_URL + 'course/detail',
    UPDATE_RECORDING: API_BASE_URL + 'course/update-recording',
    GET_ALL_ACTIVE_AND_DEL: API_BASE_URL + 'course/get-all-active-and-del',
  },
  LESSIONSLOT: {
    GET_ALL: API_BASE_URL + 'lessonslot/get-all',
    SAVE: API_BASE_URL + 'lessonslot/save',
  },
  DEVICE: {
    GET_ALL: API_BASE_URL + 'device/get-all',
    SAVE: API_BASE_URL + 'device/save',
  },
  CLASS: {
    GET_ALL: API_BASE_URL + 'class/get-all',
    GET_ALL_WITH_ACTIVE_USERS: API_BASE_URL + 'class/get-all-with-active-users',
    SAVE: API_BASE_URL + 'class/save',
  },
  FILE: {
    UPLOAD_AVATAR: API_BASE_URL + 'file/upload-avatar',
    USER_AVATAR: 'user-avatar',
    UPLOAD_PDFS: API_BASE_URL + 'file/upload-pdfs',
    MATERIAL_LAKE: 'material-lake',
    UPLOAD_FILES_BY_PRESIGNED: API_BASE_URL + 'file/upload-files-by-presigned',
    CONFIRM_UPLOAD: API_BASE_URL + 'file/confirm-upload',
    DOWNLOAD_ZIP: API_BASE_URL + 'file/download-zip',
    DOWNLOAD_PRESIGNED: API_BASE_URL + 'file/download-presigned',
  },
  MATERIAL: {
    SAVE: API_BASE_URL + 'material/save',
    GET_ALL: API_BASE_URL + 'material/get-all',
    UPDATE_STATUS: API_BASE_URL + 'material/update-status',
    GET_DOCS: API_BASE_URL + 'material/docs',
    GET_BY_IDS: API_BASE_URL + 'material/get-by-ids',
    GET_ALL_ACTIVE: API_BASE_URL + 'material/get-all-active-and-del',
  },
  DASHBOARD: {
    GET_TODAY_CLASSES: API_BASE_URL + 'dashboard/today-classes',
    TEACHER_ASSIGNED_CLASSES: API_BASE_URL + 'dashboard/assigned-classes',
    TIMELINE_EVENTS: API_BASE_URL + 'dashboard/timeline-events',
    MONTHLY_SCHEDULE: API_BASE_URL + 'dashboard/monthly-schedule',
    CURRENT_COURSE: API_BASE_URL + 'dashboard/current-course',
    EVENTS: API_BASE_URL + 'dashboard/events',
  },
  SCHEDULE: {
    CREATE: API_BASE_URL + 'schedule/create',
    UPDATE: API_BASE_URL + 'schedule/update',
    DELETE: API_BASE_URL + 'schedule/delete',
    EVENTS: API_BASE_URL + 'schedule/events',
    GET_BY_ID: (scheduleId: string) => API_BASE_URL + `schedule/${scheduleId}`
  },
  MASTER: {
    ONLINE_MEETING_INFORMATION: API_BASE_URL + 'master/online-meeting-information',
  },
  ATTENDANCE: {
    ONLINE_ATTENDANCE: API_BASE_URL + 'attendance/online-attendance',
    PREVIEW_ONLINE_ATTENDANCE: API_BASE_URL + 'attendance/preview-online-attendance',
    IMPORT_CSV: API_BASE_URL + 'attendance/import-csv',
    VIDEO_DETAIL: API_BASE_URL + 'attendance/video-detail',
    MY_SUBMISSION: API_BASE_URL + 'attendance/my-submission',
    SUBMIT: API_BASE_URL + 'attendance/submit',
    SAVE_PROGRESS: API_BASE_URL + 'attendance/save-progress',
  },
  EVENT: {
    UPDATE_ISPUBLISH: API_BASE_URL + 'event/update-ispublish',
  },
  GOOGLE: {
    AUTH_LOGIN: API_BASE_URL + 'google-auth/login',
    AUTH_STATUS: API_BASE_URL + 'google-auth/status',
    AUTH_UNLINK: API_BASE_URL + 'google-auth/unlink',
    MEET_CREATE: API_BASE_URL + 'gcp/meet/create',
    MEET_LIST: API_BASE_URL + 'gcp/meet/list',
    MEET_DELETE: (number: number) => `${API_BASE_URL}gcp/meet/${number}`,
    MEET_UPDATE: (number: number) => `${API_BASE_URL}gcp/meet/${number}`,
    MEET_UPDATE_ALIAS: (number: number) => `${API_BASE_URL}gcp/meet/${number}/alias`,
    MEET_UPDATE_ATTENDEES: (number: number) => `${API_BASE_URL}gcp/meet/${number}/attendees`,
    MEET_UPDATE_INVITED: (number: number) => `${API_BASE_URL}gcp/meet/${number}/invited`,
  },
  VIDEO: {
    STATUS: (eventId: string) => API_BASE_URL + `events/${eventId}/video/status`,
    COOKIE: (eventId: string) => API_BASE_URL + `events/${eventId}/video/cookie`,
    TRANSCODE: (eventId: string) => API_BASE_URL + `events/${eventId}/video/transcode`,
  },
};
